/* eslint-disable react/prop-types */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { AriaAttributes, AriaRoles } from '../../constants/AccessibilityConstants';

import './Icon.scss';

export default class extends React.Component {
  static propTypes = {
    qaTag: PropTypes.string,
    glyph: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    title: PropTypes.string,
  };

  render() {
    const ariaAttributes = Object.assign({}, this.props.aria || {});
    const focusableAttribute = {};
    const classes = classNames(['Icon', this.props.className]);

    if (this.props.title && typeof this.props.title === 'string') {
      const titleName = `title_${this.props.title.split(' ').join('_')}`;
      ariaAttributes[AriaAttributes.LABELLEDBY] = titleName;
    }

    if (this.props.focusable) {
      focusableAttribute.focusable = 'false';
    }

    const Component = this.props.glyph;
    return (
      <Component
        className={classes}
        data-qa={this.props.qaTag}
        style={this.props.style}
        role={AriaRoles.IMG}
        {...focusableAttribute}
        {...ariaAttributes}
        xlinkTitle={this.props.title}
      />
    );
  }
}
